// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var BackbeatActionsController = function ($scope, BackbeatAction, SettingsSimulation) {
    const title = "Backbeat Action";
    SettingsSimulation.get({}, function (data) { $scope.simulationEnabled = data.SimulationEnabled });
    BackbeatAction.getNames(function(data) { $scope.actionNames = data; });
    
    $scope.filter = { status: 'NotSleeping', actionName: '', entity: ''};
    $scope.load = function () {       
        $scope.actions = $scope.paginator(function (options, callback) {
            return BackbeatAction.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, $scope.filter, 20);
    };

    $scope.load();

    $scope.setActionStatus = function (action, status) {
        $scope.confirm(title, "Are you sure you want to change "+action.ActionName+" status to " + status + "?",
            function () {
                BackbeatAction.setActionStatus(
                    { id : action.Id,
                        currentStatus: action.Status,
                        newStatus: status
                    },
                    $scope.load);
            }        
        );
    };

    $scope.resetTimestamp = function (action) {
        $scope.confirm(title, "Are you sure you want to reset timestamp?", 
            function (){
                BackbeatAction.resetTimestamp({ id : action.Id}, $scope.load);            
            });    
    };

    $scope.requeue = function (action) {
        $scope.confirm(title, "Are you sure you want to re-queue?",
            function (){
                BackbeatAction.requeue({ id : action.Id}, $scope.load);
            });
    };

};
BackbeatActionsController.$inject = ['$scope', 'BackbeatAction', 'SettingsSimulation'];
